
import { Link } from 'react-router-dom';

const AboutSection = () => {
  return (
    <section className="py-12 sm:py-16 md:py-24 px-4 sm:px-6 bg-gradient-to-b from-sub/30 to-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center">
          <div>
            <div className="inline-block bg-white px-4 py-1 rounded-full mb-4">
              <span className="text-gray-500 text-xs font-medium tracking-wider uppercase">About Us</span>
            </div>
            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-gray-900 mb-4 sm:mb-6 leading-tight">
              患者様一人ひとりの<br />
              体質と症状に合わせた<br />
              <strong className="text-primary">オーダーメイド治療</strong>
            </h2>
            <p className="text-gray-600 text-sm sm:text-base leading-relaxed mb-6 sm:mb-8">
              <strong>2000年の開業以来、岡山市を中心に地域の皆様の健康をサポート</strong>してまいりました。当院では、<strong>東洋医学の伝統的な理論</strong>と<strong>最新の医学知識</strong>を融合させ、一人ひとりの体質や症状に合わせた<strong>オーダーメイドの鍼灸治療</strong>を提供しています。
            </p>
            <p className="text-gray-600 text-sm sm:text-base leading-relaxed mb-6 sm:mb-8">
              <strong>肩こり・腰痛・頭痛</strong>などの慢性的な痛みから、<strong>自律神経の不調</strong>、<strong>美容鍼</strong>まで、幅広い症状に対応。経験豊富な<strong>国家資格保持者</strong>が、丁寧なカウンセリングと施術で、あなたの健康をサポートいたします。
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 bg-primary text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-medium text-sm sm:text-base hover:bg-primary-dark transition-colors whitespace-nowrap cursor-pointer"
            >
              当院について詳しく見る
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-2 gap-3 sm:gap-4">
            <div className="h-64 sm:h-72 md:h-80">
              <img
                src="https://public.readdy.ai/ai/img_res/81467ee9fbdbc61707f3f57da23d68ed.jpg"
                alt="明るい待合室"
                className="w-full h-full object-cover rounded-2xl sm:rounded-3xl"
              />
            </div>
            <div className="h-64 sm:h-72 md:h-80 mt-8 sm:mt-12">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20scene%20of%20Japanese%20acupuncturist%20in%20white%20coat%20having%20friendly%20consultation%20with%20smiling%20Japanese%20patient%2C%20both%20sitting%20comfortably%20in%20modern%20clinic%2C%20natural%20conversation%20showing%20trust%20and%20care%2C%20soft%20natural%20lighting%2C%20professional%20yet%20welcoming%20atmosphere%2C%20clean%20clinical%20interior%20with%20plants%2C%20genuine%20smiles%20and%20positive%20interaction%2C%20high%20quality%20photography&width=800&height=600&seq=about-consultation&orientation=landscape"
                alt="スタッフと患者の会話"
                className="w-full h-full object-cover rounded-2xl sm:rounded-3xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
